
import axios from 'axios';
import axiosRetry from 'axios-retry';
import Moment from 'moment';
import 'moment/locale/ru';
import { extendMoment } from 'moment-range';

import React, { Component, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { Backdrop, CircularProgress } from "@material-ui/core";
import { UserContext, UserProvider, LoginForm } from 'components/User';

import './App.scss';
import AppMenu from './AppMenu';
import AppLogo from './AppLogo';
import Dashboard from 'components/Dashboard';
import { UserToolbar } from 'components/User/Toolbar';
import ClientRoutes from 'components/Client/Routes';
import OrderRoutes from 'components/Order/Routes';
import TariffRoutes from 'components/Tariff/Routes';
import CatalogRoutes from 'components/Catalog/Routes';
import DriverRoutes from 'components/Driver/Routes';
import TractorUnitRoutes from 'components/TractorUnit/Routes';
import SemiTrailerRoutes from 'components/SemiTrailer/Routes';
import PointRoutes from 'components/Point/Routes';
import ServiceRoutes from 'components/Service/Routes';
import TimetableRoutes from 'components/Timetable/Routes';
import ScheduleRoutes from 'components/Schedule/Routes';
import PlanningRoutes from 'components/Planning/Routes';
import PageNotFound from 'core/PageNotFount';
import { MenuItems } from "./MenuItems";
import Error403 from "./Error403";

const moment = extendMoment(Moment);
moment.locale('ru');

axios.defaults.withCredentials = true;
axios.interceptors.request.use((config) => {
  if (!config.url.startsWith('http')) {
    if (config.url[0] !== '/') {
      config.url = `/api/${config.url}`;
    }

    if (config.url[config.url.length - 1] !== '/' && config.url.indexOf('?') === -1) {
      config.url += '/';
    }
  }

  return config;
});

axiosRetry(axios, {
  retries: 2,
  retryCondition: (error) => {
    return error.message === 'Network Error';
  },
  retryDelay: (retryCount) => 1000
});

class App extends Component {
  render() {
    return (
      <SnackbarProvider maxSnack={3} anchorOrigin={{vertical: 'top', horizontal: 'center'}} autoHideDuration={3000}>
        <UserProvider>
          <UserContext.Consumer>
            {value => {
              if (value.state.isInitialized) {
                return value.state.isAuthenticated ? (
                  <>
                    {value.data.resourcetype === 'AccountStaff' && (
                      <Router>
                        <Dashboard
                          menu={<AppMenu items={MenuItems} />}
                          bottomToolbar={<UserToolbar />}
                        >
                          <Switch>
                            <Redirect exact from="/" to="/order" />
                            <Route path="/client">
                              <ClientRoutes />
                            </Route>
                            <Route path="/order">
                              <OrderRoutes />
                            </Route>
                            <Route path="/planning">
                              <PlanningRoutes />
                            </Route>
                            <Route path="/tariff">
                              <TariffRoutes />
                            </Route>
                            <Route path="/catalog">
                              <CatalogRoutes />
                            </Route>
                            <Route path="/driver">
                              <DriverRoutes />
                            </Route>
                            <Route path="/tractor_unit">
                              <TractorUnitRoutes />
                            </Route>
                            <Route path="/semi_trailer">
                              <SemiTrailerRoutes />
                            </Route>
                            <Route path="/point">
                              <PointRoutes />
                            </Route>
                            <Route path="/service">
                              <ServiceRoutes />
                            </Route>
                            <Route path="/schedule">
                              <ScheduleRoutes />
                            </Route>
                            <Route path="/timetable">
                              <TimetableRoutes />
                            </Route>
                            <Route
                              path="/refresh"
                              exact
                              component={(props) => {
                                // eslint-disable-next-line
                                useEffect(() => props.history.goBack(), []);
                                return <></>;
                              }}
                             />
                            <Route component={PageNotFound} />
                          </Switch>
                        </Dashboard>
                      </Router>
                    )}
                    {value.data.resourcetype !== 'AccountStaff' && (
                      <Error403/>
                    )}
                  </>
                ) : (
                  <React.Fragment>
                    <LoginForm logo={<AppLogo />} />
                  </React.Fragment>
                )
              }
              else {
                return (
                  <Backdrop open={true} invisible={true}>
                    <CircularProgress color="primary" />
                  </Backdrop>
                )
              }
            }}
          </UserContext.Consumer>
        </UserProvider>
      </SnackbarProvider>
    );
  }
}

export default App;
